import { ComponentProps } from "react";

interface Props extends ComponentProps<"svg"> {
  width: string;
  height: string;
}

const CANIcon = ({ width, height }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_332_206)">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#F5F5F5"
      />
      <path
        d="M21.9997 11.9997C21.9997 8.03507 19.6925 4.60944 16.3475 2.99194V21.0074C19.6925 19.3899 21.9997 15.9643 21.9997 11.9997Z"
        fill="#D80027"
      />
      <path
        d="M2 11.9997C2 15.9643 4.30723 19.3899 7.65219 21.0074V2.99194C4.30723 4.60944 2 8.03507 2 11.9997Z"
        fill="#D80027"
      />
      <path
        d="M13.7394 13.3044L15.4785 12.4348L14.609 12V11.1304L12.8698 12L13.7394 10.2609H12.8698L12.0003 8.95654L11.1307 10.2609H10.2611L11.1307 12L9.39156 11.1304V12L8.52203 12.4348L10.2611 13.3044L9.82637 14.1739H11.5655V15.4783H12.435V14.1739H14.1742L13.7394 13.3044Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_332_206">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CANIcon;
